<arm-dialog (onCancel)="cancel()"
            (onSubmit)="submit()"
            [hideOkButton]="!isAuthorized"
            [disabled]="!mapForm.form.valid"
            [title]="title">

    <form #mapForm="ngForm" autocomplete="off" class="main-container">
        <mat-form-field class="fullWidth">
            <mat-label>Name</mat-label>
            <input matInput required [(ngModel)]="scopeObj.name" [disabled]="isEditMode" name="name">
            <mat-error>
                Name is <strong>required</strong>
            </mat-error>
        </mat-form-field>

        <div class="form-row">
            <mat-form-field class="fullWidth">
                <mat-label>Weight</mat-label>
                <input matInput [(ngModel)]="scopeObj.weight" type="number" min="1"
                       max="100" name="weight" required>
            </mat-form-field>

            <mat-form-field class="fullWidth">
                <mat-label>Transport Type</mat-label>
                <mat-select [(ngModel)]="scopeObj.transportType" name="voipPeerId">
                    <mat-option *ngFor="let item of transportProtocolOptions" [value]="item.value">
                        {{item.text}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="form-row" *ngIf="isEditMode">
            <mat-form-field class="fullWidth">
                <mat-label>Operative State</mat-label>
                <mat-select [(ngModel)]="scopeObj.operState" name="operState">
                    <mat-option *ngFor="let item of operStateOptions" [value]="item.value">
                        {{item.text}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="fullWidth">
                <mat-label>Quality</mat-label>
                <mat-select [(ngModel)]="scopeObj.result" name="result">
                    <mat-option *ngFor="let item of qualityOptions" [value]="item.value">
                        {{item.text}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="form-row">
            <div class="form-column">
                <span class="node-configuration-title">Node 1</span>
                <mat-form-field class="fullWidth">
                    <mat-label>Node</mat-label>
                    <mat-select [(ngModel)]="scopeObj.selectedSrcNode" [disabled]="isEditMode" required
                                (selectionChange)="updateSrcRIOptions(); updateDestNodeOptions()" name="selectedSrcNode">
                        <mat-option *ngFor="let item of options.srcNodes" [value]="item.id">
                            {{item.name}}
                        </mat-option>
                    </mat-select>
                    <mat-error>
                        Source node is <strong>required</strong>
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="fullWidth">
                    <mat-label>Routing Interface</mat-label>
                    <mat-select [(ngModel)]="scopeObj.selectedSrcRI" [disabled]="isEditMode" (selectionChange)="updateEdgesName()"
                                name="selectedSrcRI" required>
                        <mat-option *ngFor="let item of options.srcRIs" [value]="item.id">
                            {{item.name}}
                        </mat-option>
                    </mat-select>
                    <mat-error>
                        Source Routing Interface is <strong>required</strong>
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="form-column">
                <span class="node-configuration-title">Node 2</span>
                <mat-form-field class="fullWidth">
                    <mat-label>Node</mat-label>
                    <mat-select [(ngModel)]="scopeObj.selectedDestNode" [disabled]="isEditMode"
                                (selectionChange)="updateDestRIOptions(); updateDestNodeOptions()" name="selectedDestNode" required>
                        <mat-option *ngFor="let item of options.destNodes" [value]="item.id">
                            {{item.name}}
                        </mat-option>
                    </mat-select>
                    <mat-error>
                        Destination node is <strong>required</strong>
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="fullWidth">
                    <mat-label>Routing Interface</mat-label>
                    <mat-select [(ngModel)]="scopeObj.selectedDestRI" [disabled]="isEditMode" (selectionChange)="updateEdgesName()"
                                name="selectedDestRI" required>
                        <mat-option *ngFor="let item of options.destRIs" [value]="item.id">
                            {{item.name}}
                        </mat-option>
                    </mat-select>
                    <mat-error>
                        Destination Routing Interface is <strong>required</strong>
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
    </form>
</arm-dialog>
